/// <amd-module name="Environments/EnvironmentsCommon/DeleteDialog" />
import React = require("react");

import { ObservableValue, Observable } from "VSS/Core/Observable";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssLayoutManager, Components, VssComponent } from "VSS/Platform/Layout";

import { Dialog } from "VSSUI/Dialog";
import { Observer } from "VSSUI/Observer";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";

import * as Resources from "Environments/EnvironmentsCommon/Resources";

export interface IDeleteDialogProps {
    id: number;
    headerText: string;
    message: string;
    onOkClick: (id: number, closeDialog?: () => void, setDialogError?: (errorMessage: React.ReactNode) => void) => void;
    onDismiss: () => void;
    doNotDismissOnOkClick?: boolean;
}

export function getDeleteDialog(pageContext: IVssPageContext, dialogProps: IDeleteDialogProps): void {
    const { id, headerText, message, onOkClick } = dialogProps;
    const layoutManager = pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
    id > 0 && layoutManager.renderCallout(onDismiss => {
        return (
            <DeleteDialog
                id={id}
                headerText={headerText}
                message={message}
                onOkClick={onOkClick}
                onDismiss={onDismiss} />
        );
    });
}

class DeleteDialog extends VssComponent<IDeleteDialogProps>{
    public render() {
        const props = this.props;
        const isDialogOpen = new ObservableValue<boolean>(false);
        const buttonsDisabled = new ObservableValue<boolean>(false);
        const errorMessage = new ObservableValue<React.ReactNode>(null);
        const onDismiss = () => {
            isDialogOpen.value = false;
            props.onDismiss();
        }

        isDialogOpen.value = true;

        return (
            <Observer isDialogOpen={isDialogOpen} buttonsDisabled={buttonsDisabled} errorMessage={errorMessage}>
                {(observerProps: { isDialogOpen: boolean, buttonsDisabled: boolean }) => {
                    return observerProps.isDialogOpen ? (
                        <Dialog
                            titleProps={{ text: props.headerText }}
                            footerButtonProps={[
                                {
                                    text: Resources.CancelButtonText,
                                    disabled: observerProps.buttonsDisabled,
                                    onClick: onDismiss
                                },
                                {
                                    text: Resources.DeleteButtonText,
                                    disabled: observerProps.buttonsDisabled,
                                    primary: true,
                                    onClick: () => {
                                        buttonsDisabled.value = true;
                                        props.onOkClick(props.id, () => isDialogOpen.value = false, (errorMessageElement) => {
                                            errorMessage.value = errorMessageElement;
                                            buttonsDisabled.value = false;
                                        });
                                        if (!props.doNotDismissOnOkClick) {
                                            isDialogOpen.value = false;
                                        }
                                    }
                                }
                            ]}
                            onDismiss={onDismiss}
                        >
                            {errorMessage.value &&
                                <MessageCard
                                    severity={MessageCardSeverity.Error}
                                    onDismiss={() => errorMessage.value = null}
                                >
                                    {errorMessage.value}
                                </MessageCard>
                            }
                            {props.message}
                        </Dialog>
                    ) : null;
                }}
            </Observer>
        );
    }
}

Components.add("deleteEnvironmentResourceDialog", DeleteDialog);
